<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-header">
                        <div class="card-header-actions">

                            <div class="col-lg-6 col-md-8 col-12 card-header-filter-box mb-3">
                                <div class="row align-items-end">
                                    <div class="col-12 col-sm-6 card-header-search-box">
                                        <div class="input-group">
                                            <input class="form-control search-input" type="text"
                                                   :placeholder="$t('main.search')"
                                                   v-model="filter.search" @keypress.enter="initList">
                                            <div class="input-group-append">
                                                <button class="all-btn search-btn" @click="initList">
                                                    <i class="fa fa-search"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 col-sm-6 card-header-select-box mt-2 mt-sm-0">
                                        <div class="form-group">
                                            <label style="color: grey">{{$t("main.searchStatus")}}</label>
                                            <div class="position-relative">
                                                <select class="form-control"
                                                        v-model="filter.status"
                                                        @change="onChangeStatus">
                                                    <option value=""></option>
                                                    <option value="NotReady">{{$t("realEstate.status.notReady")}}
                                                    </option>
                                                    <option value="Open">{{$t("realEstate.status.open")}}</option>
                                                    <option value="InCorrection">{{$t("realEstate.status.inCorrection")}}</option>
                                                    <option value="Pending">{{$t("realEstate.status.pending")}}</option>
                                                    <option value="AssignedToEvaluator">
                                                        {{$t("realEstate.status.assignedToEvaluator")}}
                                                    </option>
                                                    <option value="NotFullyEvaluated">
                                                        {{$t("realEstate.status.notFullyEvaluated")}}
                                                    </option>
                                                    <option value="Evaluated">{{$t("realEstate.status.evaluated")}}
                                                    </option>
                                                    <option value="Confirmed">{{$t("realEstate.status.confirmed")}}
                                                    </option>
                                                    <option value="Rejected">{{$t("realEstate.status.rejected")}}
                                                    </option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-6 col-md-8 col-12 card-header-filter-box mb-3">
                                <div class="row align-items-end">
                                    <div class="col-12 col-sm-6 card-header-select-box mt-2 mt-sm-0">
                                        <div class="form-group">
                                            <label style="color: grey">Кўчмас мулк статус</label>
                                            <div class="position-relative">
                                                <select class="form-control"
                                                        v-model="filter.targetStatus"
                                                        @change="onChangeStatus">
                                                    <option value=""></option>
                                                    <option value="NotReady">{{$t("realEstate.status.notReady")}}
                                                    </option>
                                                    <option value="Open">{{$t("realEstate.status.open")}}</option>
                                                    <option value="InCorrection">{{$t("realEstate.status.inCorrection")}}</option>
                                                    <option value="Pending">{{$t("realEstate.status.pending")}}</option>
                                                    <option value="AssignedToEvaluator">
                                                        {{$t("realEstate.status.assignedToEvaluator")}}
                                                    </option>
                                                    <option value="NotFullyEvaluated">
                                                        {{$t("realEstate.status.notFullyEvaluated")}}
                                                    </option>
                                                    <option value="Evaluated">{{$t("realEstate.status.evaluated")}}
                                                    </option>
                                                    <option value="Confirmed">{{$t("realEstate.status.confirmed")}}
                                                    </option>
                                                    <option value="Rejected">{{$t("realEstate.status.rejected")}}
                                                    </option>
                                                    <option value="InIdentification">{{$t("realEstate.status.inIdentification")}}</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-6 col-md-8 col-12 card-header-filter-box">
                                <div class="row align-items-end">
                                    <div class="col-12 col-sm-6 card-header-select-box mt-2 mt-sm-0">
                                        <div class="form-group">
                                            <label>{{$t('client.field.province')}} <span class="red">*</span></label>
                                            <v-select
                                                    label="name"
                                                    v-model="province"
                                                    :filterable="false"
                                                    :options="provinces"
                                                    @search="onProvinceSearch"
                                                    @search:focus="onProvinceFocus"
                                                    @change="onChangeFilterProvince"
                                            >
                                                <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                                            </v-select>
                                        </div>
                                    </div>

                                    <div class="col-12 col-sm-6 card-header-select-box mt-2 mt-sm-0">
                                        <div class="form-group">
                                            <label>{{$t('client.field.region')}} <span class="red">*</span></label>
                                            <v-select
                                                    label="name"
                                                    v-model="region"
                                                    :filterable="false"
                                                    :options="regions"
                                                    @search="onRegionSearch"
                                                    @search:focus="onRegionFocus"
                                                    @change="onChangeFilterRegion"
                                            >
                                                <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                                            </v-select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-6 col-md-8 col-12 card-header-filter-box">
                                <div class="row align-items-end">
                                    <div class="col-12 col-sm-6 card-header-select-box mt-2 mt-sm-0">
                                        <div class="form-group">
                                            <label>{{$t("report.date.startDate")}}</label>
                                            <date-picker
                                                    class="form-control"
                                                    format="dd/MM/yyyy"
                                                    v-model="filterStartDate"
                                                    :clear-button="true"
                                            ></date-picker>
                                        </div>
                                    </div>

                                    <div class="col-12 col-sm-6 card-header-select-box mt-2 mt-sm-0">
                                        <div class="form-group">
                                            <label>{{$t("report.date.endDate")}}</label>
                                            <date-picker
                                                    class="form-control"
                                                    format="dd/MM/yyyy"
                                                    v-model="filterEndDate"
                                                    :clear-button="true"
                                            ></date-picker>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 justify-content-md-end mt-2 card-header-btns-box">
                              <label class="mr-3 mt-3 font-weight-bold" v-if="results && results.total">Жами: {{results.total}}</label>
                            </div>
                        </div>
                    </div>
                    <div class="card-body table-responsive">
                        <div class="table-wrapper">
                          <table class="table table-hover">
                              <thead>
                                  <tr>
                                      <th>#</th>
                                      <th width="12%">{{$t('expert2.field.name')}}</th>
                                      <th>{{$t("newRealEstate.field.plus.createdBy")}}</th>
                                      <th width="12%">Қарз олувчи</th>
                                      <th>{{$t("realEstate.field.status")}} / {{$t("newRealEstate.field.plus.source")}}</th>
                                      <th width="10%">{{$t('expert2.field.createdDate')}}</th>
                                      <th width="10%">{{$t("newRealEstate.field.plus.assignedDateToAgent")}}</th>
                                      <th width="10%">{{$t("newRealEstate.field.plus.assignedDateToEvaluator")}}</th>
                                      <th width="13%">{{$t("newRealEstate.field.plus.confirmedDate")}}</th>
                                      <th width="18%">{{$t("newRealEstate.field.plus.agent")}}</th>
                                      <th>{{$t("newRealEstate.field.plus.buildingType")}}</th>
                                      <th class="text-center" v-if="hasPermission('E_BAHOLASH_EXPERT2_REAL_ESTATE_VIEW')">
                                          {{$t("realEstate.field.action")}}
                                      </th>
                                  </tr>
                              </thead>
                              <tbody v-if="!loading && results && results.data">
                                  <tr v-for="result in results.data" :key="result.id">
                                      <td>
                                          {{result.id}}
                                        <button v-tooltip="'Кадастр маълумоти топилмаган. Холатни билиш учун босинг.'" class="btn btn-sm" @click="getFixError(result)" v-if="isCadastreFixError(result)">
                                          <i class="fa fa-warning"></i>
                                        </button>
                                      </td>
                                      <td>
                                          {{result.name}}
                                          <div class="text-secondary">{{result.cadastreDocNumber}}</div>
                                          <div class="text-secondary">
                                              Банк ходими рақами:
                                              <br>
                                              <i class="fa fa-phone"></i>
                                              <span>{{result.bankPhone}}</span>
                                          </div>
                                          <div class="text-secondary">
                                              Мулк эгаси рақами:
                                              <br>
                                              <i class="fa fa-phone"></i>
                                              <span>{{result.ownerPhone}}</span>
                                          </div>
                                          <div class="text-success" v-if="result.province">
                                              <span>{{result.province.name}},</span>
                                          </div>
                                          <div class="text-success" v-if="result.region">
                                              <span>{{result.region.name}}, </span>
                                          </div>
                                          <div class="text-success">
                                              <span>{{result.address}} </span>
                                          </div>
                                          <div class="badge badge-primary">{{$t('realEstate.name')}}: #{{result.targetId}}</div>
                                          <real-estate-status :status="result.targetStatus" />
                                          <div v-if="result.buildingCount"> Бинолар сони <span>{{result.buildingCount}}</span></div>
                                      </td>
                                      <td>{{result.clientDto != null ? result.clientDto.firmName: ""}}</td>
                                      <td>
                                        <div class="text-secondary" v-if="result.borrower">{{result.borrower.borrowerName}}</div>
                                      </td>
                                      <td class="text-center">
                                          <div class="text-success" v-if="result.realEstate && result.realEstate.registryInformationDto && result.realEstate.registryInformationDto.bitrix24PersonDealId && (result.status ==='InCorrection' || result.targetStatus ==='InCorrection')">
                                            Битрих24: {{result.realEstate.registryInformationDto.bitrix24PersonDealId}}
                                          </div>
                                          <real-estate-status :status="result.status" />
                                          <div v-if="result.source === 'ONLINE_PLUS'" class="text-secondary">{{$t("realEstate.createType.online_plus")}}</div>
                                          <div v-if="result.source === 'INSIDE'" class="text-secondary">{{$t("realEstate.createType.ourselves")}}</div>
                                          <div v-if="result.source === 'ONLINE'" class="text-secondary">{{$t("realEstate.createType.online")}}</div>
                                          <div v-if="result.source === 'API_MIB'" class="text-secondary">{{$t("realEstate.createType.apiMib")}}</div>
                                          <div v-if="result.source === 'ANDROID'" class="text-secondary">{{$t("realEstate.createType.android")}}</div>
                                          <div v-if="result.source === 'API_BANK'" class="text-secondary">{{$t("realEstate.createType.api_bank")}}</div>
                                      </td>
                                      <td>
                                          <div class="text-secondary">{{result.createdBy ? result.createdBy.name : ''}}</div>
                                          <div class="text-secondary" v-if="result.status ==='Rejected'">{{$t('expert2.action.reject')}}: <br> {{new Date(result.updatedDate) | dateFormat('DD/MM/YYYY HH:mm')}}</div>
                                          <div class="text-secondary" v-else-if="result.status ==='InCorrection'">{{$t('expert2.action.inCorrection')}}: <br> {{new Date(result.updatedDate) | dateFormat('DD/MM/YYYY HH:mm')}}</div>
                                          <div class="text-secondary" v-else-if="result.status ==='Open'">{{$t('expert2.action.open')}}: <br> {{new Date(result.statusChangeDate) | dateFormat('DD/MM/YYYY HH:mm')}}</div>
                                          <div class="text-secondary" v-else-if="result.pendingDate">{{$t('expert2.action.pending')}}: <br> {{new Date(result.pendingDate) | dateFormat('DD/MM/YYYY HH:mm')}}</div>
                                          <div v-else-if="result.statusChangeDate">{{new Date(result.statusChangeDate) | dateFormat('DD.MM.YYYY HH:mm')}}</div>
                                          <div v-else>{{new Date(result.createdDate) | dateFormat('DD.MM.YYYY HH:mm')}}</div>
                                      </td>
                                      <td>
                                          <span v-if="result.assignedToEvaluatorDate">{{new Date(result.assignedToEvaluatorDate) | dateFormat('DD/MM/YYYY HH:mm')}}</span>
                                      </td>
                                      <td>
                                          <span v-if="result.assignedToEvaluatorDate">{{new Date(result.assignedToEvaluatorDate) | dateFormat('DD/MM/YYYY HH:mm')}}</span>
                                      </td>
                                      <td>
                                          <span v-if="result.confirmedDate">{{new Date(result.confirmedDate) | dateFormat('DD/MM/YYYY HH:mm')}}</span>
                                      </td>
                                      <td>
                                          <template v-if="(result.status !== 'Pending' && result.status !== 'Rejected') && result.agent && result.agent.name">
                                              <div v-html="result.agent.name"></div>
                                          </template>
                                          <template v-else-if="result.status === 'Pending' && !isCadastreFixError(result) && new Date(result.createdDate) < new Date('2025-10-25T15:44:00')">
                                              <v-select v-model="result.agent" label="text"
                                                        class="select-style"
                                                        v-if="result.source === 'ONLINE_PLUS' && hasPermission('E_BAHOLASH_EXPERT2_REAL_ESTATE_BIND_AGENT')"
                                                        :options="agents"
                                                        :filterable="false"
                                                        @search="onAgentSearch"
                                                        @change="onAgentChange(result)"
                                                        @search:focus="onAgentFocus(result)">
                                                  <template slot="option" slot-scope="option" v-if="option">
                                                      <div v-html="option.name"></div>
                                                  </template>
                                                  <template slot="selected-option"
                                                            v-if="result && result.agent && result.agent.name">
                                                      <div v-html="result.agent.name"
                                                           @click="$eventBus.$emit('search:focus')"></div>
                                                  </template>
                                                  <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                                              </v-select>
                                          </template>
                                      </td>
                                      <td>
                                          <template v-if="result.buildingType">{{result.buildingType.name}}</template>
                                          <template v-else>
                                              <v-select v-model="result.buildingType" label="name"
                                                        :options="buildingTypes"
                                                        class="select-style"
                                                        :filterable="false"
                                                        @search:focus="onBuildingFocus"
                                              >
                                                  <template slot="option" slot-scope="option" v-if="option && option.name">
                                                      <div v-html="option.name"></div>
                                                  </template>
                                                  <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                                              </v-select>
                                          </template>
                                      </td>
                                      <td>
                                          <button class="all-btn add-btn table-action"
                                                  v-if="(result.status === 'Pending' && result.agent && result.agent.id) && hasPermission('E_BAHOLASH_EXPERT2_REAL_ESTATE_BIND_AGENT')"
                                                  v-tooltip="'Жўнатиш'"
                                                  :disabled="processing"
                                                  @click="onBeforePending(result)"
                                          >
                                              <i class="fa fa-check-circle"></i>
                                          </button>
                                          <router-link :to="'/e-appraisal/expert2/real-estate/view/' + result.id"
                                                       v-tooltip="'Эксперт2 кўчмас мулк деталлари'"
                                                       class="all-btn view-btn table-action"
                                                       v-if="hasPermission('E_BAHOLASH_EXPERT2_REAL_ESTATE_VIEW')">
                                              <i class="fa fa-image"></i>
                                          </router-link>
                                          <button class="all-btn delete-btn table-action"
                                                  v-if="(result.status === 'Open' || result.status === 'Pending' || result.status === 'AssignedToEvaluator' || result.status === 'NotFullyEvaluated') && (result.targetStatus !== 'InIdentification' || result.targetStatus !== 'Confirmed' || result.targetStatus !== 'Evaluated') && hasPermission('E_BAHOLASH_EXPERT2_REJECT')"
                                                  :disabled="processing"
                                                  v-tooltip="'Рад этиш'"
                                                  @click="onReject(result)"
                                          >
                                              <i class="fa fa-reply"></i>
                                          </button>
                                          <button class="all-btn dark-btn table-action"
                                                  v-tooltip="'Илова хужжатлари'"
                                                  @click="onShowDocumentModal(result)"
                                          >
                                              <i class="fa fa-file-pdf-o"></i>
                                          </button>
                                          <button class="all-btn view-btn table-action"
                                                  v-if="result.status === 'Open' && result.targetStatus === 'Open' && hasPermission('E_BAHOLASH_REAL_ESTATE_BIND_AGENT')"
                                                  v-tooltip="'Идентификацияга жунатиш'"
                                                  :disabled="processing"
                                                  @click="handleResendToIdentification(result.realEstate)"
                                          >
                                            <i class="fa fa-refresh"></i>
                                          </button>
<!--                                          <button class="all-btn add-btn table-action"-->
<!--                                                  v-if="result.targetStatus === 'Open' && (result.realEstate.registryInformationDto && !result.realEstate.registryInformationDto.openStatusCode) && hasPermission('E_BAHOLASH_UPLOAD_REAL_ESTATE_REGISTRY_INFORMATION_DATA')"-->
<!--                                                  v-tooltip="'Маълумотларни юклаш'"-->
<!--                                                  :disabled="processing"-->
<!--                                                  @click="handleOpenRegistryInformationByQrCodeUrl(result.realEstate)"-->
<!--                                          >-->
<!--                                            <i class="fa fa-check"></i>-->
<!--                                          </button>-->
                                          <router-link :to="'/new-real-estate-plus/view/' + result.targetId"
                                                       v-tooltip="'Кўчмас мулк деталлари'"
                                                       class="all-btn add-btn table-action"
                                                       v-if="result.targetStatus === 'InIdentification' && hasPermission('NEW_REAL_ESTATE_VIEW')"
                                          >
                                            <i class="fa fa-image"></i>
                                          </router-link>
                                      </td>
                                  </tr>
                              </tbody>
                          </table>
                        </div>
                        <div class="text-center">
                            <div class="loader mt-5 mb-5" v-if="loading"></div>
                            <span class="no-data mt-5 mb-5"
                                  v-if="!loading && results && results.data && results.data.length===0">{{$t("messages.list.empty")}}</span>
                        </div>
                        <div class="row" v-if="!loading && results && results.total && results.total > 1">
                            <div class="col-12 pt-3 pb-3">
                                <b-pagination :total-rows="results.total" v-model="filter.page.page"
                                              :per-page="filter.page.size" @change="onPageChange">
                                </b-pagination>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <expert2-reject-comment @handle-reject-save="handleRejectSave"/>
        <expert2-doc-view-modal></expert2-doc-view-modal>
        <ConstructionCompletionPercentageModal @handle-completion-data="handleCompletionData"/>
    </div>
</template>

<script>
import initFilterModel from '@/shared/filter';
import bPagination from 'bootstrap-vue/es/components/pagination/pagination';
import AdvancedFilter from '@/shared/filters/advancedFilter';
import Expert2RejectComment from '@/components/Expert2RejectComment';
import DatePicker from "vuejs-datepicker";
import Expert2DocViewModal from '@/components/Expert2DocViewModal'
import ConstructionCompletionPercentageModal from "@/components/real-estate/ConstructionCompletionPercentageModal.vue";
import RealEstateStatus from "@/components/real-estate/RealEstateStatus.vue";

export default {
        components: {
            'b-pagination': bPagination,
            Expert2RejectComment,
            DatePicker,
            Expert2DocViewModal,
            ConstructionCompletionPercentageModal,
            RealEstateStatus
        },
        data() {
            return {
                loading: false,
                processing: false,
                filter: initFilterModel(),
                agentFilter: initFilterModel(),
                filterBuildingType: new AdvancedFilter(),
                filterProvince: initFilterModel(),
                filterRegion: initFilterModel(),
                province: null,
                region: null,
                provinces: [],
                regions: [],
                agents: [],
                buildingTypes: [],
                results: null,
                requestId: null,
                filterStartDate: null,
                filterEndDate: null,
            }
        },
        methods: {
            initList() {
                this.loading = true;

              this.filter.startDate = null
              this.filter.endDate = null

              if(this.filterStartDate) {
                this.filter.startDate = new Date(this.filterStartDate.getFullYear(), this.filterStartDate.getMonth(), this.filterStartDate.getDate() + 1);
                this.filter.startDate.setUTCHours(0, 0, 0, 0);
              }
              if(this.filterEndDate) {
                this.filter.endDate = new Date(this.filterEndDate.getFullYear(), this.filterEndDate.getMonth(), this.filterEndDate.getDate() + 2);
                this.filter.endDate.setUTCHours(0, 0, 0, 0);
              }

                this.$http.post('admin/e-appraisal/expert2/list', this.filter)
                    .then(res => {
                        this.results = res.data;
                        this.loading = false;
                    }, err => {
                        console.log(err);
                        this.loading = false;
                    });
            },
            onPageChange(page) {
                this.filter.page.page = page;
                this.initList();
            },
            onChangeStatus() {
                const vm = this;
                if (!this.filter.status) {
                    vm.filter.status = null
                }

                if (!this.filter.targetStatus) {
                    vm.filter.targetStatus = null
                }

                this.initList()
            },
            ownerName(data) {
                let owner = data.ownerClient;
                if (owner && owner.type && owner.type === 'Legal') {
                    return "<b>" + (owner.firmName ? owner.firmName : " ") + "</b>" + "<br>" + (owner.fullName ? owner.fullName : " ")
                } else {
                    return owner && owner.fullName ? owner.fullName : " "
                }
            },
            onAgentSearch(searchTxt, loading) {
                loading(true);
                this.agents = [];
                this.agentFilter.search = searchTxt;
                this.agentFilter.province = null;
                this.$http.post('user/agent', this.agentFilter)
                    .then(res => {
                        this.agents = res.data.data;
                        loading(false);
                        this.filter.search = '';
                    }, err => {
                        console.log(err);
                        loading(false);
                    });
            },
            onAgentFocus(data) {
                this.agentFilter.province = data.province;
                this.agents = [];
                this.agentFilter.search = '';
                this.$http.post('user/agent', this.agentFilter)
                    .then(res => {
                        this.agents = res.data.data;
                    }, err => {
                        console.log(err);
                    });
            },
            onAgentChange(data) {
                this.agentFilter.province = data.province;
            },
            onBuildingFocus() {
                this.buildingTypes = [];
                this.filterBuildingType.cadastreType = 'Notorious'
                this.filterBuildingType.onlyParentLookUp = true
                this.$http.post('building-type/list', this.filterBuildingType)
                    .then(res => {
                        if (res.data !== "" && res.data.data.length > 0) {
                            this.buildingTypes = res.data.data;
                        }
                    }, err => {
                        console.log(err);
                    });
            },
            onBeforePending(expert2) {
                let realEstate = expert2.realEstate
                if (realEstate.data && realEstate.data.values && realEstate.data.values.isCadastreError) {
                    this.$http.get(`admin/expert2/${expert2.id}`)
                        .then(res => {
                            const editData = res.data;
                            this.savePlusData(editData, expert2)
                            this.loading = false;
                        }, () => {
                            this.loading = false;
                        })
                } else {
                    this.onPending(expert2)
                }
            },
            savePlusData(editData, expert2) {
                console.log('editData = ', editData)
                let savePlusData = {}
                savePlusData.cadastreNumber = editData.cadastreDocNumber
                savePlusData.evlGoalType = editData.evlGoalType
                savePlusData.source = editData.source
                savePlusData.ownerPhoneNumber = editData.ownerPhone
                savePlusData.bankEmployeePhoneNumber = editData.bankPhone
                savePlusData.requestId = editData.requestId
                savePlusData.cadastre = editData.cadastre
                savePlusData.report = editData.report
                savePlusData.isCadastreError = false

                this.processing = true;
                this.$http.post('v3/expert2/save', savePlusData)
                    .then(res => {
                        let resData = res.data;
                        console.log(resData)
                        this.onPending(expert2)
                        this.processing = false;

                    }).catch(({response}) => {
                    console.log('error')
                    console.log(response)

                    this.$swal({
                        type: 'error',
                        title: '',
                        text: response.data.message ? response.data.message : response.data
                    });

                    this.processing = false;
                })
            },
            onPending(expert2) {
                this.processing = true;
                this.$http.post('admin/e-appraisal/expert2/bind-agent', expert2)
                    .then(res => {
                        if (res.data && res.data.code === 'DENIED') {
                            this.$swal({
                                title: this.$t('messages.common.error'),
                                text: this.$t('messages.expert2.validate'),
                                type: 'error'
                            });
                        } else if (res.data && res.data.status === 'SUCCESS') {
                            this.initList();
                        }
                        this.processing = false;
                    }, () => {
                        this.$swal({
                            title: this.$t('messages.common.error'),
                            text: this.$t('messages.expert2.error'),
                            type: 'error'
                        });
                        this.processing = false;
                    })
            },
            onReject(result) {
                this.$eventBus.$emit('Expert2RejectComment', result.id, false, "Expert2", true);
            },
            handleRejectSave() {
                this.initList();
            },
            onProvinceFocus() {
                this.provinces = [];
                this.filterProvince.search = '';
                this.$http.post('/province/list', this.filterProvince)
                    .then(res => {
                        this.provinces = res.data.data;
                    }, err => {
                        console.log(err);
                    });
            },
            onProvinceSearch(searchTxt, loading) {
                loading(true);
                this.provinces = [];
                this.filterProvince.search = searchTxt;
                this.$http.post('/province/list', this.filterProvince)
                    .then(res => {
                        this.provinces = res.data.data;
                        loading(false);
                    }, err => {
                        console.log(err);
                    });
            },
            onRegionSearch(searchTxt, loading) {
                loading(true);
                this.regions = [];
                this.filterRegion.search = searchTxt;
                this.filterRegion.provinceId = (this.province && this.province.id) ? this.province.id : 0;
                this.$http.post('/region/search', this.filterRegion)
                    .then(res => {
                        this.regions = res.data.data;
                        loading(false);
                    }, err => {
                        console.log(err);
                    });
            },
            onRegionFocus() {
                this.regions = [];
                this.filterRegion.provinceId = (this.province && this.province.id) ? this.province.id : 0;
                this.$http.post('/region/search', this.filterRegion)
                    .then(res => {
                        this.regions = res.data.data;
                    }, err => {
                        console.log(err);
                    });
            },
            getFixError(expert2) {
              this.processing = true;
              const realEstate = expert2.realEstate;
              this.requestId = expert2.requestId;

              this.$http.get('v3/real-estate/get-fix-error/' + realEstate.uuid)
                  .then(res => {
                    let resData = res.data;
                    if (resData.status === 'SUCCESS' && resData.data) {
                      let status = "ЯНГИ"
                      let type = 'info'
                      if (resData && resData.data && resData.data.processStatus === 'DONE') {
                        status = this.$t("realEstate.status.confirmed")
                        type = 'success'
                        if (this.isCadastreFixError(expert2)) {
                          let responseFixError = resData.data;
                          responseFixError.requestId = expert2.requestId

                          this.saveFixError(responseFixError)
                        }
                      } else if (resData.data.processStatus === 'IN_PROGRESS') {
                        status = this.$t("realEstate.status.notFullyEvaluated")
                      } else if (resData.data.processStatus === 'REJECT') {
                        status = this.$t("realEstate.status.rejected")
                        type = 'warning'
                      }

                      this.$swal({
                        title: this.$t('messages.common.success'),
                        text: status,
                        type: type
                      });

                    }
                    this.processing = false;

                  }).catch(({response}) => {
                    console.log('error')
                    console.log(response)

                    this.$swal({
                      type: 'error',
                      title: '',
                      text: response.data.message ? response.data.message : response.data
                    });

                    this.processing = false;
              })
            },
            saveFixError(responseFixError) {
              this.processing = true;
              this.$http.post('v3/real-estate/save-fix-error', responseFixError)
                  .then(res => {
                    console.log(res)
                    this.processing = false;
                    this.initList()

                  }).catch(({response}) => {
                    console.log('error')
                    console.log(response)

                    this.processing = false;
                    if (response.data && response.data.code === "NOT_COMPLETED") {
                      this.$eventBus.$emit('showConstructionCompletionPercentageModal');
                      return
                    }

                    this.$swal({
                      type: 'error',
                      title: '',
                      text: response.data.message ? response.data.message : response.data
                    });

              })
            },
            handleCompletionData(data) {
              this.loading = true;
              this.$http.get(`admin/v3/real-estate/${this.requestId}`)
                  .then(res => {
                    const editData = res.data;
                    editData.constructionCompletion = data.constructionCompletion
                    editData.constructionCompletionDoc = data.constructionCompletionDoc

                    this.saveRealEstatePlus(editData)
                    this.loading = false;
                  }, () => {
                    this.loading = false;
                  })
            },
            saveRealEstatePlus(realEstate) {
              this.processing = true;
              this.$http.post('admin/v3/real-estate/save', realEstate)
                  .then(res => {
                    let resData = res.data;
                    console.log(resData)
                    this.initList()
                    this.processing = false;

                  }).catch(({response}) => {
                    console.log('error')
                    console.log(response)

                    this.$swal({
                      type: 'error',
                      title: '',
                      text: response.data.message ? response.data.message : response.data
                    });

                    this.processing = false;
              })
            },
            onChangeFilterProvince() {
                if (this.regions.length) this.regions = [];
                if (this.region) this.region = null
                this.filter.region = null
                this.filter.province = null

                if (this.province) {
                    this.filter.province = this.province.code
                }

                this.initList();
            },
            onChangeFilterRegion() {
                if (this.region) {
                    this.filter.region = this.region.code
                    this.initList();
                }
            },
            onShowDocumentModal(expert2) {
                this.$eventBus.$emit('showExpert2DocumentsModal', expert2.id);
              },
          isCadastreFixError(expert2) {
            return expert2.targetStatus === 'InCorrection' || expert2.status === 'InCorrection'
          },
          saveByRegistryInformation(request) {
            this.processing = true;
            return (new Promise((resolve, reject) => {
              this.$http.post('v3/expert2/registry-info/save', request)
                  .then(res => {
                    let resData = res.data;
                    this.initList()
                    this.processing = false;
                    this.$swal({
                      type: 'success',
                      title: '',
                      text: resData.message ? resData.message : resData.data
                    });
                    resolve(resData)
                  })
                  .catch(({response}) => {
                    console.log('error')
                    console.log(response)
                    this.$swal({
                      type: 'error',
                      title: '',
                      text: response.data.message ? response.data.message : response.data
                    });

                    this.processing = false;
                    reject(response)
                  })
            }))
          },
          handleResendToIdentification(realEstate) {
            if (realEstate.requestId) {
              this.processing = true;
              this.$http.get('v3/real-estate/resend-identification/' + realEstate.requestId)
                  .then(res => {
                    console.log(res)
                    this.processing = false;
                    this.initList()

                  }).catch((response) => {
                console.log('error')
                console.log(response)

                this.processing = false;
                this.$swal({
                  type: 'error',
                  title: '',
                  text: response.data.message ? response.data.message : response.data
                });
              })
            }
          },
          handleOpenRegistryInformationByQrCodeUrl(realEstate) {
            if (realEstate.registryInformationDto && realEstate.registryInformationDto.qrCodeUrl) {
              window.open(realEstate.registryInformationDto.qrCodeUrl, '_blank');
            } else {
              let fixErrorRequest = {
                cadastreNumber: realEstate.cadastreDocNumber,
                description: "Текширинг qr код маълумотлари йўқ",
                requestId: realEstate.requestId,
                pinfl: realEstate.registryInformationDto.pinfl,
                tin: realEstate.registryInformationDto.inn
              }
              this.sendFixError(fixErrorRequest)
            }
          },
          sendFixError(fixErrorRequest) {
            this.processing = true;
            this.$http.post('/v3/real-estate/send-fix-error', fixErrorRequest).then(res => {
              if (res.status === 200) {
                this.initList()
              }
              this.processing = false;
            }).catch((response) => {
              console.log('error')
              console.log(response)
              this.$swal({
                icon: 'error',
                title: '',
                text: response.data.message ? response.data.message : response.data
              });

              this.processing = false;
            });
          }
        },
        created() {
            this.filterProvince.page.size = 1000;
            this.filterRegion.page.size = 1000;
            this.filter.targetType = 'Building'
            this.initList();

            this.$eventBus.$on('eExpert2RealEstateChanged', () => {
              this.initList();
            });
        }
    }
</script>

<style scoped>
    .select-style, .select-styles .dropdown-men {
        min-width: 200px;
    }
</style>